import createRecipientWell from 'owa-readwrite-recipient-well/lib/utils/createRecipientWell';
import { action } from 'satcheljs/lib/legacy';
export default action('showBccWell')(function showBccWell(viewState) {
    if (!viewState.bccRecipientWell) {
        viewState.bccRecipientWell = createRecipientWell(viewState.findPeopleFeedbackManager, [], viewState.toRecipientWell ? viewState.toRecipientWell.contactPicker : undefined);
    }
});
//# sourceMappingURL=showBccWell.js.map